module.exports = __webpack_public_path__ + "img/img_page_05_02.20581b78.png";